<app-breadcrumb 
  [title]="'Listado Extractos'" 
  [items]="['Extractos']" 
  [active_item]="'Listado Extractos'">
</app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header bg-primary">
      <h5 class="text-uppercase text-white"><strong>Listado De Extractos</strong></h5>
    </div>

    <div class="card-body custom-datatable noscroll">

      <!-- Buscador -->
      <div class="row mb-3">
        <div class="col-12 col-md-3 ms-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar..."
              [(ngModel)]="searchText"
              (input)="filterData()"
            />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive my-4">
        <table class="table table-hover table-bordered" id="tblExtractos">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>ID</strong></th>
              <th class="text-center"><strong>FUEC</strong></th>
              <th class="text-center"><strong>CONTRATO</strong></th>
              <th class="text-center"><strong>INTERNO</strong></th>
              <th class="text-center"><strong>PLACA</strong></th>
              <th class="text-center"><strong>CONTRATANTE</strong></th>
              <th class="text-center"><strong>FECHA SALIDA</strong></th>
              <th class="text-center"><strong>FECHA REGRESO</strong></th>
              <th class="text-center"><strong>ORIGEN</strong></th>
              <th class="text-center"><strong>DESTINO</strong></th>
              <th class="text-center"><strong>ESTADO</strong></th>
              <th class="text-center"><strong>USUARIO</strong></th>
              <th class="text-center"><strong>REGISTRO</strong></th>
              <th class="text-center"><strong>OPCION</strong></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let planilla of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
              <td class="text-center">{{ planilla.idfuec }}</td>
              <td class="text-center">{{ planilla.nfuec }}{{ formatearContrato(planilla.contrato) }}{{ formatearContrato(planilla.idfuec) }}</td>
              <td class="text-center">{{ formatearContrato(planilla.contrato) }}</td>
              <td class="text-center">{{ planilla.interno }}</td>
              <td class="text-center">{{ planilla.placa }}</td>
              <td class="text-center">{{ planilla.nitc }}</td>
              <td class="text-center">{{ planilla.finicial | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ planilla.ffinal | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ planilla.origen }}</td>
              <td class="text-center">{{ planilla.destino }}</td>
              <td class="text-center">
                <span class="badge" [ngClass]="getEstadoColor(planilla.estado)">
                  {{ planilla.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                </span>
              </td>
              <td class="text-center">{{ planilla.usuario }}</td>
              <td class="text-center">{{ planilla.registro | date:'dd/MM/yyyy' }} 
              <td>
                <div class="action text-center">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item ">                                            
                      <a href="javascript:void(0)" (click)="imprimirFuec(planilla.idfuec)" ngbTooltip="Imprimir">
                        <i class="icon-printer"></i>
                      </a>
                    </li>
                    <li class="list-inline-item delete">
                      
                      <a href="javascript:void(0)" (click)="avisoInactivarPlanilla(planilla.idfuec)" ngbTooltip="Inactivar">
                        <i class="icon-trash"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" (click)="gestionarPasajeros(planilla)" ngbTooltip="Listado de Pasajeros">
                        <i class="icofont icofont-people"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Controles de paginación -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-2">
        
        <!-- Selector registros -->
        <div class="d-flex align-items-center">
          <label for="pageSize1" class="me-2">Mostrar:</label>
          <select id="pageSize1" class="form-select form-select-sm w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
            <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
          </select>
          <span class="ms-2">registros</span>
        </div>

        <!-- Total registros -->
        <div class="text-center">
          <span class="badge bg-primary"><b>Total: {{ filteredTableItems.length || 0 }}</b></span>
        </div>

        <!-- Paginador -->
        <div class="text-end">
          <pagination-controls
            (pageChange)="page1 = $event" 
            [maxSize]="5"
            [directionLinks]="true"
            [autoHide]="true"
            previousLabel="Anterior" 
            nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>

      <!-- Botones de exportación -->
      <div class="card-body">
        <div class="btn-showcase text-center d-flex flex-wrap justify-content-center gap-2">
          <button class="btn btn-outline-success btn-sm" type="button" placement="top" ngbTooltip="Exportar a Excel"
            (click)="exportarExcel('tblExtractos', 'Listado_Extractos')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>

          <button class="btn btn-outline-danger btn-sm" type="button" placement="top" ngbTooltip="Exportar a PDF"
            (click)="exportToPDF('tblExtractos', 'Listado_Extractos', 'Listado de Extractos')">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>

          <button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Crear"
            (click)="CrearVehiculo()">
            <i class="icofont icofont-plus"></i> CREAR
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
 <div
  class="toast-container position-fixed bottom-0 end-0 p-3"
  style="z-index: 1055"
  aria-live="polite"
  aria-atomic="true"
>
  <div
    *ngIf="mostrandoToast"
    class="toast show align-items-center text-white bg-primary border-0"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="d-flex">
      <div class="toast-body">
        <div class="spinner-border spinner-border-sm me-2" role="status"></div>
        Generando Documento...
      </div>
    </div>
  </div>
</div>